import React, { useCallback, useRef, useState } from 'react';
import { TInput } from './input.types';
import { Preloader } from './components/preloader';
import { InputStyled, AdornmentWrapper } from './input.styled';

export const Input: React.FC<TInput> = ({
    id,
    inputProps,
    className,
    isLoading,
    isError,
    disabled,
    active,
    shrink,
    value,
    adornment,
    onChange,
    myRef,
    hasBtnCount = 0,
    width,
    ...props
}) => {
    /*console.debug(
        `Field ${props.name} is re-rendered. ${value}. ${isError}`,
    );*/

    const inputRef = useRef<HTMLInputElement>(null);
    const [isActive, setActive] = useState<boolean>(false);

    const onBlur = useCallback(() => {
        const ref = inputRef?.current;
        if (ref) ref.blur && ref.blur();
        setActive(false);
    }, []);

    const onFocus = useCallback(() => {
        const ref = inputRef.current;
        if (ref) ref.focus && ref.focus();
        setActive(true);
    }, []);

    const onClick = () => {
        const ref = inputRef.current;
        if (ref) ref.focus && ref.focus();
        setActive(true);
    };

    return (
        <InputStyled
            ref={myRef}
            className={className}
            active={isActive}
            onClick={onClick}
            onBlur={onBlur}
            onFocus={onFocus}
            isLoading={isLoading}
            shrink={shrink}
            disabled={disabled}
            isError={isError}
            hasBtnCount={hasBtnCount}
            width={width}
        >
            <AdornmentWrapper
                before={!!adornment?.before}
                after={!!adornment?.after}
            >
                {adornment?.before && <span>{adornment?.before}</span>}
                <input
                    id={id}
                    {...props}
                    value={value}
                    onChange={onChange}
                    ref={inputRef}
                    {...inputProps}
                />
                {adornment?.after && <span>{adornment?.after}</span>}
            </AdornmentWrapper>
            {isLoading && <Preloader />}
        </InputStyled>
    );
};

export const InputOptimized = React.memo(Input, (prevProps, nextProps) => {
    return (
        prevProps.className === nextProps.className &&
        prevProps.value === nextProps.value &&
        prevProps.isError === nextProps.isError &&
        prevProps.isLoading === nextProps.isLoading &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.active === nextProps.active
    );
});

export default InputOptimized;
